import { List, Map } from 'immutable';
import { takeEvery, put, call, select } from 'redux-saga/effects';
import { getAuthToken } from './auth';
import { fetchUserContracts, getNewContractUrl, getContractPdfUrl } from '../services/backendService'

import { namespaceActionObject } from './helpers'

// TYPES
export const REDUCER_ACTIONS = namespaceActionObject('CONTRACTS')({
  SET_CONTRACTS : 'SET_CONTRACTS',
  FETCH_CONTRACTS_PENDING : 'FETCH_CONTRACTS_PENDING',
  FETCH_CONTRACTS_SUCCESS : 'FETCH_CONTRACTS_SUCCESS',
  FETCH_CONTRACTS_ERROR : 'FETCH_CONTRACTS_ERROR',
  SIGN_CONTRACT : 'SIGN_CONTRACT',
  UPDATE_CONTRACT_URL : 'UPDATE_CONTRACT_URL',
  CLEAR_CONTRACTS : 'CLEAR_CONTRACTS',
  FIRE_FETCH_CONTRACTS : 'FIRE_FETCH_CONTRACTS',
  GET_NEW_URL : 'GET_NEW_URL',
  FETCH_PDF_URL_FOR_SIGN_CONTRACT : 'FETCH_PDF_URL_FOR_SIGN_CONTRACT',
  FETCH_CONTRACT_PDF_PENDING : 'FETCH_CONTRACT_PDF_PENDING',
  FETCH_CONTRACT_PDF_ERROR : 'FETCH_CONTRACT_PDF_ERROR',
  FETCH_CONTRACT_PDF_SUCCESS: 'FETCH_CONTRACT_PDF_SUCCESS',
  SET_PDF_URL : 'SET_PDF_URL',
  FETCH_TEMPORAL_CONTRACT_URL : 'FETCH_TEMPORAL_CONTRACT_URL'
});

export const REDUCER_STATUS = {
  CONTRACTS_NOT_ASKED : 'CONTRACTS_NOT_ASKED',
  CONTRACTS_ASKED : 'CONTRACTS_ASKED',
  CONTRACTS_SUCCESS : 'CONTRACTS_SUCCESS',
  CONTRACTS_ERROR : 'CONTRACTS_ERROR',
  CONTRACT_PDF_ASKED : 'CONTRACT_PDF_ASKED',
  CONTRACT_PDF_ERROR : 'CONTRACT_PDF_ERROR',
  CONTRACT_PDF_SUCCESS : 'CONTRACT_PDF_SUCCESS'
};


export const CONTRACT_URL_STATUS = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  NOT_FETCHED: 'NOT_FETCHED'
}

// ACTIONS
export const setContracts = (contracts) => ({
  type: REDUCER_ACTIONS.SET_CONTRACTS,
  payload: contracts
});

export const fetchContractsPending = () => ({
  type: REDUCER_ACTIONS.FETCH_CONTRACTS_PENDING
})

export const fetchContractsError = (error) => ({
  type: REDUCER_ACTIONS.FETCH_CONTRACTS_ERROR,
  payload: error
})

export const fetchContractsSuccess = () => ({
  type: REDUCER_ACTIONS.FETCH_CONTRACTS_SUCCESS,
})

export const markContractAsSigned = (index, pdfUrl) =>({
  type: REDUCER_ACTIONS.SIGN_CONTRACT,
  payload: {index, pdfUrl}
});

export const setNewContractUrl = (index, newUrl) => ({
  type: REDUCER_ACTIONS.UPDATE_CONTRACT_URL,
  payload: {index, newUrl }
})

export const clearContracts = () => ({
  type: REDUCER_ACTIONS.CLEAR_CONTRACT_URL
})

export const fireFetchContracts = (idUser) => ({
  type : REDUCER_ACTIONS.FIRE_FETCH_CONTRACTS,
  payload : idUser
})

export const getNewUrl = (index, memberId) => ({
  type: REDUCER_ACTIONS.GET_NEW_URL,
  payload: {index, memberId}
})

export const fireFetchPdfUrlForSignContract = (index) => ({
  type: REDUCER_ACTIONS.FETCH_PDF_URL_FOR_SIGN_CONTRACT,
  payload: index
})

export const fetchContractPdf = (index) =>({
  type: REDUCER_ACTIONS.FETCH_TEMPORAL_CONTRACT_URL,
  payload: index
})

export const fetchContractPdfPending = () =>({
  type: REDUCER_ACTIONS.FETCH_CONTRACT_PDF_PENDING,
})

export const fetchContractPdfError = () =>({
  type: REDUCER_ACTIONS.FETCH_CONTRACT_PDF_ERROR,
})

export const fetchContractPdfSuccess = () =>({
  type: REDUCER_ACTIONS.FETCH_CONTRACT_PDF_SUCCESS,
})

export const setTemporalPdfUrl = (urlPdf) => ({
  type : REDUCER_ACTIONS.SET_PDF_URL,
  payload : urlPdf
})

// SAGAS

export function* watchContracts() {
  yield takeEvery(REDUCER_ACTIONS.FIRE_FETCH_CONTRACTS, fetchContracts)
}

export function* watchGetNewContractUrl() {
  yield takeEvery(REDUCER_ACTIONS.GET_NEW_URL, fetchNewContractUrl)
}

export function* watchfetchPdfUrlForSignContract() {
  yield takeEvery(REDUCER_ACTIONS.FETCH_PDF_URL_FOR_SIGN_CONTRACT, fetchPdfUrlForSignContract)
}

export function* watchFetchTemporalUrlContract() {
  yield takeEvery(REDUCER_ACTIONS.FETCH_TEMPORAL_CONTRACT_URL, fetchTemporalUrlContract)
}

export function* fetchContracts(action) {
  try {
    yield put(fetchContractsPending())
    const token = yield select(getAuthToken)
    const { contracts } = yield call(fetchUserContracts, action.payload, token);
    yield put(setContracts(contracts))
  } catch (error) {
    yield put(fetchContractsError(error))
    console.warn("Failed while fetching contracts", error);
  }
}

export function* fetchNewContractUrl(action) {
  try {
    yield put(fetchContractsPending())
    const { index, memberId } = action.payload;
    const contracts = yield select(getContractsList)
    const token = yield select(getAuthToken)
    const signatureId = contracts.get(index).get('signatureRequestId');
    const contractURL = yield call(getNewContractUrl, memberId, signatureId, token);
    yield put(setNewContractUrl(index, contractURL))
  } catch (error) {
    yield put(fetchContractsError(error))
    console.warn("Failed while fetching new contract url", error);
  }
}

export function* fetchPdfUrlForSignContract(action) {
  try {
    yield put(fetchContractsPending())
    const index = action.payload;
    const contracts = yield select(getContractsList)
    const signatureId = contracts.get(index).get('signatureRequestId');
    const token = yield select(getAuthToken)
    const urlPdf = yield call(getContractPdfUrl, signatureId, token);
    yield put(setNewContractUrl(index, urlPdf));
    yield put(fetchContractPdfSuccess());
  } catch (error) {
    yield put(fetchContractsError(error))
    console.warn("Failed while fetching new contract url for sign", error);
  }
}

export function* fetchTemporalUrlContract(action) {
  try {
    yield put(fetchContractPdfPending());
    const index = action.payload;
    const contracts = yield select(getContractsList)
    const signatureId = contracts.get(index).get('signatureRequestId');
    const token = yield select(getAuthToken)
    const urlPdf = yield call(getContractPdfUrl, signatureId, token);
    yield put(setTemporalPdfUrl(urlPdf));
  } catch (error) {
    yield put(fetchContractPdfError(error));
    console.warn("Failed while fetching contract temporal url", error);
  }
}

// STATE MAPPERS

export const getContractsList = (store) => store.contracts.get('contractList');
export const getTemporalPdfUrl = (store) => store.contracts.get('pdfUrl');
export const temporalPdfFetched = (store) => store.contracts.get('status') === REDUCER_STATUS.CONTRACT_PDF_SUCCESS;
export const areContractsLoading = (store) => store.contracts.get('status') !== REDUCER_STATUS.CONTRACTS_SUCCESS && store.contracts.get('status') !== REDUCER_STATUS.CONTRACT_PDF_SUCCESS;
export const allContractsSigned = (store) => store.contracts.get('contractList').findIndex(contract => !contract.get('signed')) === -1;

const initState = Map({
  status: REDUCER_STATUS.CONTRACTS_NOT_ASKED,
  contractList: List(),
  pdfUrl : ''
});

export default (state = initState, action) => {
  let index;
  let newUrl;
  let pdfUrl;
  let prev;
  let newContract;
  let list;
  const { type, payload } = action;
  switch (type) {
    case REDUCER_ACTIONS.SET_CONTRACTS:
      list = List(payload).map(Map);
      return state.merge({ status: REDUCER_STATUS.CONTRACTS_SUCCESS, contractList: list });
    case REDUCER_ACTIONS.FETCH_CONTRACTS_PENDING:
      return state.set('status', REDUCER_STATUS.FETCH_CONTRACTS_PENDING);
    case REDUCER_ACTIONS.FETCH_CONTRACTS_ERROR:
      return state.merge({ status: REDUCER_STATUS.FETCH_CONTRACTS_ERROR, error: payload });
    case REDUCER_ACTIONS.FETCH_CONTRACTS_SUCCESS:
      return state.set('status', REDUCER_STATUS.FETCH_CONTRACT_PDF_SUCCESS)
    case REDUCER_ACTIONS.SIGN_CONTRACT:
      ({ index, pdfUrl } = payload);
      prev = state.get('contractList').get(index);
      newContract = prev
        .set('signed', true)
        .set('contractURL', pdfUrl);
      return state.set('contractList', state.get('contractList').set(index, newContract));
    case REDUCER_ACTIONS.UPDATE_CONTRACT_URL:
      ({ index, newUrl } = action.payload);
      newContract = state.get('contractList').get(index).set("contractURL", newUrl)
      return state.set('contractList', state.get('contractList').set(index, newContract));
    case REDUCER_ACTIONS.SET_PDF_URL:
      return state.merge({ status: REDUCER_STATUS.CONTRACT_PDF_SUCCESS, pdfUrl: payload })
    case REDUCER_ACTIONS.FETCH_CONTRACT_PDF_ERROR:
      return state.merge({ status: REDUCER_STATUS.FETCH_CONTRACT_PDF_ERROR, error: payload })
    case REDUCER_ACTIONS.FETCH_CONTRACT_PDF_PENDING:
      return state.set('status', REDUCER_STATUS.FETCH_CONTRACT_PDF_PENDING);
    case REDUCER_ACTIONS.CLEAR_CONTRACTS:
      return initState
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/contracts.js